/**
 * Labstep
 *
 * @module components/Entity/Search/ActionBar
 * @desc Bar with bulk selection and pagination action
 */

import { EntitySearchBulkActions as BulkActions } from 'labstep-web/components/Entity/Search/BulkActions';
import { useBulkSelectContext } from 'labstep-web/contexts/bulk-select/hook';
import { ParamsStateContextProvider } from 'labstep-web/contexts/params-state';
import type React from 'react';
import styles from './styles.module.scss';
import type { EntitySearchActionBarProps } from './types';

export const EntitySearchActionBar: React.FC<
  EntitySearchActionBarProps
> = ({ bulkActions, entityName }) => {
  const { isAtLeastOneSelected } = useBulkSelectContext();
  if (!isAtLeastOneSelected) {
    return null;
  }
  return (
    <div className={styles.actionsBar}>
      <ParamsStateContextProvider value={{}}>
        <BulkActions
          entityName={entityName}
          bulkActions={bulkActions}
        />
      </ParamsStateContextProvider>
    </div>
  );
};
